export default "__VITE_ASSET__m8GAGfa9cuJ5yLVKM$V41w__"